import { MessageSquarePlus } from 'lucide-react'
import { FEEDBACK_URL } from '../../lib/constants'

export default function FeedbackButton() {
  return (
    <a
      href={FEEDBACK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground shadow-lg transition-opacity hover:opacity-90"
    >
      <MessageSquarePlus className="h-4 w-4" />
      Feedback
    </a>
  )
}
